import AskInputModal from './AskInputModal';

export default AskInputModal;
